import { computed, getCurrentInstance, ref } from '@vue/composition-api'

export default function useCampaignList() {
  const vm = getCurrentInstance().proxy

  const campaignListTable = ref([])

  const tableColumns = [
    { text: '#', value: 'id', width: '5%' },
    { text: 'NAME', value: 'campaignName', width: '75%' },
    { text: 'PRODUCTS', value: 'productCount', width: '10%' },
    {
      text: 'ACTIONS',
      value: 'actions',
      align: 'center',
      sortable: false,
      width: '10%',
    },
  ]

  const campaigns = computed({
    get: () => vm.$store.getters['campaigns/items'],
  })
  const loading = computed({
    get: () => vm.$store.getters['campaigns/loading'],
  })
  const meta = computed({
    get: () => vm.$store.getters['campaigns/meta'],
  })
  const filters = computed({
    get: () => vm.$store.getters['campaigns/filters'],
  })
  const options = computed({
    get: () => vm.$store.getters['campaigns/options'],
    set: val => vm.$store.dispatch('campaigns/setOptions', { ...options.value, ...val }),
  })
  const search = computed({
    get: () => vm.$store.getters['campaigns/search'],
    set: val => vm.$store.dispatch('campaigns/setSearch', val),
  })
  const totalCampaignListTable = computed({
    get: () => vm.$store.getters['campaigns/meta'].total,
  })

  const fetchItems = () => vm.$store.dispatch('campaigns/fetchItems')
  const setOptions = val => vm.$store.dispatch('campaigns/setOptions', val)
  const setFilters = val => vm.$store.dispatch('campaigns/setFilters', val)
  const handleReorder = val => vm.$store.dispatch('campaigns/order', val)

  const init = () => {
    fetchItems()
  }

  const destroy = () => {}

  return {
    campaignListTable,
    tableColumns,

    totalCampaignListTable,
    loading,

    fetchItems,

    meta,
    search,
    campaigns,
    options,
    filters,

    setOptions,
    setFilters,
    handleReorder,

    init,
    destroy,
  }
}
